<div class="operating-personal__container">
    <div class="settings d-flex flex-row">
    </div>
    <div class="operating-personal__header d-flex flex-row">
      <div>
        <h4>{{ 'COMPANY_PROFILE.STAFF' | translate }} </h4>
      </div>
      <!-- <div>
          <div>
              Search Component
          </div>
        </div> -->
    </div>
    <div class="operating-personal__additional d-flex flex-row">
      <div class="d-flex flex-row">
        <mat-icon>person</mat-icon><span class="text-uppercase">{{'COMPANY_PROFILE.HOSTS'| translate}}</span>
      </div>
      <div (click)="openAddHost()" style="text-align: right; cursor: pointer;">{{'COMPANY_PROFILE.ADD_NEW'| translate}}
        <span>+</span>
      </div>
    </div>
    <div *ngIf="hostsList?.length != 0 else noHosts" class="host-list custom-scroll-bar">
      <app-host-item *ngFor="let host of hostsList" [host]="host" [company]="company" [companyId]="companyId">
      </app-host-item>
    </div>
    <ng-template #noHosts>
      <div class="container-fluid mt-4">
        <div class="row">
          <div class="col-12 no-items">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <img src="./assets/images/icons/reservations_empty@3x.png" alt="no-reservations" class="img-responsive">
              <p class="mt-2">{{'COMPANY_PROFILE.NO_HOSTS' | translate}}.
                {{'COMPANY_PROFILE.YOU_CAN_CREATE_ON_ADD_NEW'|translate}} <span style="color:cyan">+</span></p>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>